




















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Faq } from '@/models/Faq';

@Component
export default class FaqList extends Vue {
    protected blockTitle!: string;
    protected faqs!: Faq[];
    protected useMicrodata!: boolean;

    constructor() {
        super();

        this.blockTitle = JSON.parse(this.$attrs['data-blocktitle']);
        this.faqs = JSON.parse(this.$attrs['data-faq-list']);
        this.useMicrodata = JSON.parse(this.$attrs['data-use-microdata']);

        // console.log(this.useMicrodata);
        // console.log(this.faqs);

        this.$attrs['data-blocktitle'] = '';
        this.$attrs['data-faq-list'] = '';
        this.$attrs['data-use-microdata'] = '';
    }
}
